import UAParser from 'ua-parser-js'
import API from '@/services/api'
import { VERSION } from '@/config'
import { captureException } from '@/errors'

function sendDeviceInfo(fingerPrintUUID, cableType = null) {
  let parser = null
  let manufacturer = null
  let model = null
  let browser = null
  let browserVersion = null
  try {
    parser = new UAParser(navigator.userAgent || navigator.vendor || window.opera)
  } catch (error) {
    console.log(error)
  }

  if (parser.getDevice().vendor) {
    manufacturer = parser.getDevice().vendor
  }
  if (parser.getDevice() && parser.getDevice().model) {
    model = parser.getDevice().model
  }

  if (parser.getBrowser() && parser.getBrowser().name && parser.getBrowser().version) {
    browser = parser.getBrowser().name
    browserVersion = parser.getBrowser().version
  }

  try {
    const params = {
      device_id: fingerPrintUUID,
      manufacturer: manufacturer,
      model: model,
      platform: browser,
      platform_version: browserVersion,
      app_version: VERSION,
      carrier_name: null,
      country_code: null,
      phone_number: null,
      sim_serial_number: null,
      cable_type: cableType
    }
    API.post('customer/device_info', params, { timeout: 2000 }).catch(() => {
      // Just ignore errors as this is non-critical
    })
  } catch (error) {
    // Ignore invalid parsing errors too
  }
}

function updateCableTypeInfo(fingerPrintUUID, cableType) {
  try {
    const params = {
      cable_type: cableType,
      device_id: fingerPrintUUID
    }
    API.put('customer/device_info', params, { timeout: 2000 }).catch(() => {
      // Just ignore errors as this is non-critical
    })
  } catch (error) {
    // Ignore
  }
}

export { sendDeviceInfo, updateCableTypeInfo }
